<template>
	<div>
		<div class="bannerS">
			<banner jsClass="image_url" :picS="banner_list" :navigation="false" itemType="image_url"></banner>
		</div>
		<div class="widthBox">
			<div v-if="video" class="video">
				<video controls :src="video" class="radius-8" autoplay  loop="loop"></video>
			</div>
			<div class="product">
				<h1 class="title">{{ $t("Feature Product") }}</h1>
				<div>
					<el-row :gutter="10" class="acea-row row-middle">
						<el-col :span="10" :xs="24" ><div><img class="img100 radius-8" :src="goods_info.thumbnail_url" alt=""></div></el-col>
						<el-col :span="13" :xs="24"  :offset="1" class="infos hidden-xs-only">
							<div class="txt">{{goods_info.name}}</div>
							<div class="info2">{{goods_info.desc}}</div>
							<div v-if="goods_info.sku" class="txt f-14" style="margin-bottom: 20px;">${{goods_info.sku.price}}</div>
							<div v-for="(info,index) in goods_info.instructions_list" :key="index">
								<div class="info">{{info.name}}</div>
								<div class="info2">{{info.value}}</div>
							</div>
							<router-link class="see_more warn_bg f-14" :to="'/Products_details?id='+goods_info.id">{{ $t("See more") }}</router-link>
						</el-col>
						<el-col :span="13" :xs="24" class="hidden-sm-and-up">
							<div class="txt">{{goods_info.name}}</div>
							<div class="info2">{{goods_info.desc}}</div>
							<div v-if="goods_info.sku" class="txt f-14" style="margin-bottom: 20px;">${{goods_info.sku.price}}</div>
							<div v-for="(info,index) in goods_info.instructions_list" :key="index">
								<div class="info">{{info.name}}</div>
								<div class="acea-row row-middle row-between " style="flex-wrap: nowrap;">
									<div class="info2" style="margin: 0;width: 50%;">{{info.value}}</div>
									<router-link v-if="(index+1) == goods_info.instructions_list.length" class="see_more warn_bg f-14" style="margin: 0;" :to="'/Products_details?id='+goods_info.id">{{ $t("See more") }}</router-link>
								</div>
							</div>
						</el-col>
					</el-row>
				</div>
			</div>
			<div class="news">
				<h1 class="title f-28 cursor" @click="toUrl('/News')">{{ $t("News") }}</h1>
				<div>
					<el-row :gutter="10" class="acea-row row-middle new">
						<el-col  v-for="(item,index) in article_list" :key="index" class="cursor" style="margin-bottom: 20px;" :span="8" :xs="24" @click.native="toUrl('/News_details?id='+item.id)"> 
							<div class="body">
								<img class="img100 radius-8" :src="item.thumbnail_url" alt="">
								<div class="text">
									<div class="txt f-14 line_Hide_2">{{item.title}}</div>
									<div class="info3 line_Hide_2">{{item.desc}}</div>
									<div class="acea-row row-between  row-middle btn2" >
										<span class="info2" style="">{{item.create_time}}</span>
										<router-link class="warn_txt f-16" :to="'/News_details?id='+item.id">{{ $t("more") }}</router-link>
									</div>
								</div>
							</div>
						</el-col>
					</el-row>
				</div>
			</div>
		</div>
		<div class="banner" >
			<img :src="bannerS" class="img100" alt="" style="max-height: 440px;overflow: hidden;min-height: 160px;object-fit: cover;">
			<div class="body widthBox">
				<div class="left">
					<div class="f-56 white">{{$t("PHROMON")}}</div>
					<div class="f-32 white">{{$t("EVENTS")}}</div>
					<a target="_blank" href="http://phromonglobal.com" class="btn txt f-14 cursor">{{$t("join us")}}</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import banner from '@/components/banner.vue'
	export default {
		name: 'index',
		components: {
			banner,
		},
		computed: {
			video() {
				return this.$store.state.video
			},
			bannerS(){
				return this.$store.state.bannerS
			}
		},
		data() {
			return {
				indexData:{},
				article_list:[],
				goods_info:{},
				banner_list:[]

			}
		},
		created() {
			
		},
		mounted() {
			this.$api.get('api/Index/index',{}).then(res=>{
				this.indexData = res.data
				this.article_list = res.data.article_list
				this.goods_info = res.data.goods_info
				this.banner_list = res.data.banner_list
			})

		},
		methods: {
			toUrl(url){
      			this.$router.push(url)
			}
		}
	}
</script>
<style lang="scss" scoped="scoped">
	$mgt120:120px;
	.bannerS{
		overflow: hidden;
	}
	.video{
		width: 100%;
		margin-top: 80px;
		video{
			width: 100%;
		}
	}
	.product{
		margin-top: $mgt120;
		.title{
			margin-bottom: 80px;
		}
		div{
			margin-bottom: 12px;
		}
		.see_more{
			padding: 12px 24px;
			display: inline-block;
			margin-top: 20px;
			border-radius:4px ;
		}
	}
	.news{
		.title{
			margin-top:$mgt120;
			margin-bottom: 48px;
		}

		img{
			width: 100%;
			height: 278px;
			object-fit: cover;
		}
		.body{
			background: #F5F5F5;
			border-radius: 8px;
			overflow: hidden;
			.text{
				padding: 24px;
				min-height: 180px;
				margin-bottom: 0px;
				box-sizing: border-box;
				position: relative;
				width: 100%;
				.btn2{
					position: absolute;
					bottom: 24px;
					width: calc( 100% - 48px) ;
					margin-bottom: 0px;
				}
			}
			div{
				margin-bottom: 12px;
			}
		}
	}
	.banner{
		margin-top:$mgt120;
		margin-bottom: $mgt120;
		position: relative;
		.body{
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			display: flex;
			justify-content: space-around;
			align-items: center;
			text-align: center;
			.btn{
				background: #fff;
				border-radius:4px;
				padding: 12px 24px;
				margin-top: 8px;
				display: inline-block;
			}
		}
	}
	
@media screen and(max-width:768px) {
	.video,.product{
		margin-top: 56px;
	}
	.product .title{
		margin-bottom: 24px;
	}
	.news .title{
		margin-top: 56px;
		margin-bottom: 24px;
	}
	.banner{
		margin-top: 56px;
		margin-bottom: 56px;
	}
	.banner .body{
		// justify-content: flex-start;
		// text-align: left;
	}
	.banner .body{
		.f-56{
			font-size:28px;
		}
		.f-32{
			font-size:16px;
		}
		.btn{
			padding:8px 16px;
		}
	}
}
</style>
